var _circle, _circle2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIncontinenceIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 80,
  height: 65,
  fill: "none"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 40,
  cy: 32.5,
  r: 30,
  fill: "#F5F5F5"
})), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
  cx: 62.5,
  cy: 52,
  r: 7.5,
  fill: "#14B814"
})), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "#003252",
  clipPath: "url(#incontinence-icon_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M33.333 21.5A2.667 2.667 0 0 1 36 24.167v16a2.667 2.667 0 0 1-2.667 2.666H32a2.667 2.667 0 0 1-2.667-2.666v-16A2.667 2.667 0 0 1 32 21.5zM32 23.5a.667.667 0 0 0-.667.667v16c0 .368.299.666.667.666h1.333a.667.667 0 0 0 .667-.666v-16a.667.667 0 0 0-.667-.667zM42 21.5a2.667 2.667 0 0 1 2.667 2.667v16A2.667 2.667 0 0 1 42 42.833h-1.333A2.667 2.667 0 0 1 38 40.167v-16a2.667 2.667 0 0 1 2.667-2.667zm-1.333 2a.667.667 0 0 0-.667.667v16c0 .368.298.666.667.666H42a.667.667 0 0 0 .667-.666v-16A.667.667 0 0 0 42 23.5z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  d: "M51 29.5c1.274 0 1.5-.25 1.5-1.5 0-.545-.2-1.086-.5-1.5-.494-.676-1-1.5-1-1.5s-.51.824-1 1.5c-.3.41-.5.951-.5 1.5-.004 1.25.222 1.5 1.5 1.5m.004 1.5C49.346 31 48 29.678 48 28.05c0-.623.22-1.242.658-1.84.498-.683 1.836-2.911 1.848-2.934A.57.57 0 0 1 51 23c.205 0 .392.105.494.276.016.023 1.35 2.251 1.848 2.935.438.6.658 1.22.658 1.84.004 1.628-1.342 2.949-2.996 2.949"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "incontinence-icon_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M24 16.166h32v32H24z"
})))));
export default SvgIncontinenceIcon;